import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './reducers/authReducers';
import storeReducer from './reducers/storeReducer';
import productReducer from './reducers/productReducer';
import orderReducer from './reducers/orderReducer';
import customerReducer from './reducers/customerReducer';
import taskReducer from './reducers/taskReducer';
import analyticsReducer from './reducers/analyticsReducer';
import billingReducer from './reducers/billingReducer';
import supportReducer from './reducers/supportReducer';
import couponReducer from './reducers/couponReducer';
import userReducer from './reducers/userReducer';
import translationReducer from './reducers/translationReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  store: storeReducer,
  product: productReducer,
  order: orderReducer,
  customer: customerReducer,
  task: taskReducer,
  analytics: analyticsReducer,
  billing: billingReducer,
  support: supportReducer,
  coupon: couponReducer,
  user: userReducer,
  translation: translationReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const persistor = persistStore(store);

export { store, persistor };
